/* Pagination Helpers */
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { palette } from '../styles/theme';

export const getPages = (page, totalSize, sizePerPage) => {
    return _.times(page || 0, Number).map(n => ++n);
};

// eslint-disable-next-line react/no-multi-comp
export function NoRecordsFoundMessage ({ entities }) {
    const list = entities === null ? [] : entities;
    const { t } = useTranslation();

    return (
        <>
            {list.length === 0 && entities !== null && (
                <div className='text-center' style={{ color: palette.disabled.main }}>{t('pagination.empty')}</div>
            )}
        </>
    );
}
